import { Fragment } from "react";
import "./css/servicios.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Table from "react-bootstrap/Table";
import Image from "react-bootstrap/Image";
import BannerDatos from "../../images/servicio/mercado-valores.webp";
import BannerDatosmobile from "../../images/servicio/mercado-valores-m.webp";

function InfoRescueSheets() {
    return (
        <Fragment>
            <Container fluid={true} className="banner-servicios">
                <Row>
                    <Col md={12} className="px-0">
                        <Card>
                            <Image
                                src={BannerDatos}
                                alt="Hyundai Banner"
                                title="Hyundai Banner"
                                className="d-none d-sm-block img1"
                                fluid
                            />
                            <Image
                                src={BannerDatosmobile}
                                alt="Hyundai Banner"
                                title="Hyundai Banner"
                                className="d-block d-sm-none"
                                fluid
                            />
                        </Card>
                    </Col>
                </Row>
            </Container>
            <Container className="mb-5 pb-3 mt-4 tabla-manual">
                <Row>
                    <Col md={12}>
                        <Table responsive bordered hover>
                            <thead>
                                <tr>
                                    <th><h1 className="mercado-h1">Documentos</h1></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <a
                                            href={`/static/media/resolucion.pdf`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="manual-link"
                                        >
                                            <h2 className="mercado-h2">Resolución No. SCVS-INMV-DNAR-2022-00008514</h2>
                                        </a>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <a
                                            href={`/static/media/resolucion-35891.pdf`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="manual-link"
                                        >
                                            <h2 className="mercado-h2">Resolución No. SCVS-IRCVSQ-DRMV-2025-00035891</h2>
                                        </a>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <a
                                            href={`/static/media/calificacion.pdf`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="manual-link"
                                        >
                                            <h2 className="mercado-h2">Calificación de riesgo</h2>
                                        </a>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <a
                                            href={`/static/media/calificacion-riesgo-2025.pdf`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="manual-link"
                                        >
                                            <h2 className="mercado-h2">Calificación de riesgo - 2025</h2>
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
}
export default InfoRescueSheets;